import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ValidateformComponent } from '../../common/validateform/validateform.component';
import { Message } from 'primeng/api/message';
import { UserService } from '../../services/UserService';
import { AlertService } from 'src/app/services/AlertService';
import { AccountService } from '../../services/AccountService';

@Component({
  selector: 'app-user-forgotpassword',
  templateUrl: './user-forgotpassword.component.html',
  styleUrls: ['./user-forgotpassword.component.scss']
})
export class UserForgotpasswordComponent implements OnInit {

    @ViewChild('f', { static: true }) forgotPassFormValidate: NgForm;
    @ViewChild('forgotPassForm', { static: true }) private formValidator: ValidateformComponent;

    msgs: Message[];
    forgotPassEmail: string = '';
    passwordViewModel: any;
    requestSuccess: boolean = false;
    constructor(private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService) { }

    ngOnInit(): void {
        this.accountService.RemoveLoggedInUser();
        this.passwordViewModel = { Email:''};
    }

    forgotPasswordProcess() {
        if (this.formValidator.validateForm()) {
            this.passwordViewModel.Email = this.forgotPassEmail;
            this.userService.requestNewToken(this.passwordViewModel).subscribe(result => {
                if (result) {
                    this.requestSuccess = true;
                    this.alertService.SetMessage('success', 'Successfully request new link. You will receive a new link soon.');
                }
            },
                error => {
                    this.alertService.SetMessage('error', 'There is an error while request new link. Please make sure you have a correct email.');
                });
        }
    }

}
